module.exports = __webpack_public_path__ + "img/imgHeader_03.ea6cf5d9.png";